import { render, staticRenderFns } from "./BankingsRules.vue?vue&type=template&id=a6d89e40&"
import script from "./BankingsRules.vue?vue&type=script&lang=js&"
export * from "./BankingsRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports